import { createClient } from '@/shared/api';
import type { SendFeedbackEmailMutation, SendFeedbackEmailMutationVariables } from '@/shared/api';
import SEND_FEEDBACK_EMAIL_MUTATION from '../mutations/sendFeedbackEmail';

/**
 * Sends user feedback to the support mailbox. Runs SEND_FEEDBACK_EMAIL_MUTATION and throws sendFeedbackEmail.message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleSendFeedbackEmail = async (
  input: SendFeedbackEmailMutationVariables['input'],
): Promise<void> => {
  const client = createClient();
  const sendFeedbackEmailResult = await client.mutate<
    SendFeedbackEmailMutation,
    SendFeedbackEmailMutationVariables
  >({
    mutation: SEND_FEEDBACK_EMAIL_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = sendFeedbackEmailResult;
  // data is guaranteed by the mutation contract; downstream code already assumes it exists
  const { sendFeedbackEmail } = data!;
  if (!sendFeedbackEmail.isSuccess) {
    throw new Error(sendFeedbackEmail.message ?? undefined);
  }
};

export default handleSendFeedbackEmail;
